import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: 'always',
      staleTime: 1000 * 60 * 5, // 5 mins
      gcTime: 1000 * 60 * 30 // 30 mins
    }
  }
});
